import { render } from "./ViewBooking.vue?vue&type=template&id=722ef957&scoped=true"
import script from "./ViewBooking.vue?vue&type=script&lang=js"
export * from "./ViewBooking.vue?vue&type=script&lang=js"

import "./ViewBooking.vue?vue&type=style&index=0&id=722ef957&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722ef957"]])

export default __exports__